import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
import styled from 'styled-components';
import { variant } from 'styled-system';
import { get } from '../../styles/constant';
const fit = variant({
  prop: 'fit',
  variants: {
    small: {
      width: get('space.18'),
      height: get('space.18')
    },
    medium: {
      width: get('space.22'),
      height: get('space.22')
    },
    large: {
      width: get('space.26'),
      height: get('space.26')
    },
    xlarge: {
      width: get('space.30'),
      height: get('space.30')
    }
  }
});
const iconFit = variant({
  prop: 'fit',
  variants: {
    small: {
      fontSize: get('space.12')
    },
    medium: {
      fontSize: get('space.16')
    },
    large: {
      fontSize: get('space.20')
    },
    xlarge: {
      fontSize: get('space.24')
    }
  }
});
const variants = {
  fit,
  iconFit
};
const StepperIndicatorWrapper = styled.div.withConfig({
  shouldForwardProp: prop => !['orientation'].includes(prop)
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizelegibility;\n  position: relative;\n  ", "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])), get('fontSizes.14'), get('fontWeights.regular'), props => props.orientation === 'vertical' && {
  minHeight: '200px'
});
const StepperIndicatorList = styled.ol.withConfig({
  shouldForwardProp: prop => !['orientation'].includes(prop)
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  list-style-type: none;\n  list-style-position: unset;\n  margin: ", ";\n  padding: ", ";\n  height: 100%;\n  ", "\n"])), get('space.0'), get('space.0'), props => props.orientation === 'vertical' ? {
  flexDirection: 'column'
} : {
  flexDirection: 'row'
});
const StepperIndicatorItem = styled.li.withConfig({
  shouldForwardProp: prop => !['orientation', 'idx', 'currentindex'].includes(prop)
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  position: relative;\n  margin: ", ";\n  ", "\n\n  &:not(:last-child):after {\n    content: '';\n    position: absolute;\n    background-color: ", ";\n    ", "\n    ", "\n  }\n"])), get('space.0'), props => props.orientation === 'vertical' && {
  flexDirection: 'column',
  margin: "".concat(get('space.0'))
}, get('colors.functional.grey.300'), props => props.orientation === 'vertical' ? {
  height: 'auto',
  width: "".concat(get('space.2')(props)),
  top: "".concat(get('space.28')(props)),
  bottom: "".concat(get('space.2')(props)),
  left: "".concat(get('space.12')(props)),
  right: "".concat(get('space.12')(props))
} : {
  height: "".concat(get('space.2')(props)),
  width: 'auto',
  top: props.header ? '50%' : "".concat(get('space.12')(props)),
  bottom: props.header ? '50%' : "".concat(get('space.0')(props)),
  left: "".concat(get('space.28')(props)),
  right: "".concat(get('space.12')(props))
}, props => {
  const index = props.currentindex || 0;
  return (props.idx + 1 <= index || props.completed) && {
    backgroundColor: "".concat(props.activeColor || get('colors.primary.blue.300')(props))
  };
});
const StepperIndicatorItemInner = styled.span.withConfig({
  shouldForwardProp: prop => !['orientation'].includes(prop)
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  ", "\n"])), props => props.orientation === 'vertical' ? {
  flexDirection: 'row',
  width: 'auto'
} : {
  flexDirection: 'column',
  width: "".concat(get('space.16')(props))
});
const StepperIndicatorIconWrapper = styled.span.withConfig({
  shouldForwardProp: prop => !['orientation', 'step', 'idx', 'currentindex', 'fit', 'customIcon'].includes(prop)
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  ", "\n  border-radius: 50%;\n  border: 1px solid ", ";\n  flex-shrink: ", ";\n  color: ", ";\n  i {\n    position: absolute;\n    ", "\n  }\n  ", "\n  ", "\n"])), variants.fit, get('colors.functional.grey.300'), get('space.0'), props => props.customIcon ? get('colors.functional.grey.300') : get('colors.functional.grey.50'), variants.iconFit, props => {
  const index = props.currentindex || 0;
  return index + 1 === props.step.id && {
    border: "1px solid ".concat(props.activeColor || get('colors.primary.blue.300')(props)),
    color: "".concat(props.customIcon ? props.activeColor || get('colors.primary.blue.300')(props) : get('colors.functional.grey.50'))
  };
}, props => {
  const index = props.currentindex || 0;
  return (props.idx + 1 <= index || props.completed) && {
    border: "1px solid ".concat(props.activeColor || get('colors.primary.blue.300')(props)),
    backgroundColor: "".concat(props.activeColor || get('colors.primary.blue.300')(props)),
    color: "".concat(get('colors.functional.grey.50')(props))
  };
});
const StepperIndicatorItemLabel = styled.div.withConfig({
  shouldForwardProp: prop => !['orientation', 'idx', 'currentindex', 'defaultStyle'].includes(prop)
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), props => props.orientation === 'vertical' ? {
  display: 'flex',
  alignItems: 'center',
  height: "".concat(get('space.24')(props)),
  width: 'auto',
  margin: "0px 0px 0px ".concat(get('space.16')(props))
} : {
  display: 'block',
  height: 'auto',
  textAlign: 'center',
  minWidth: '140px',
  whiteSpace: 'nowrap',
  lineHeight: 'unset',
  border: '1px solid transparent',
  width: 'auto',
  margin: "".concat(get('space.16')(props), " 0px 0px"),
  maxWidth: '140px',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}, props => {
  const index = props.currentindex || 0;
  return props.idx === index && !props.completed && props.defaultStyle && {
    'font-weight': "".concat(get('fontWeights.bold')(props)),
    color: "".concat(get('colors.functional.grey.900')(props))
  };
});
// typeof props.steps[0].title === 'string'
const StepperIndicatorItemHeader = styled.span.withConfig({
  shouldForwardProp: prop => !['orientation', 'idx', 'currentindex'].includes(prop)
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: block;\n  height: auto;\n  text-align: center;\n  min-width: 140px;\n  white-space: nowrap;\n  line-height: unset;\n  border: 1px solid transparent;\n  width: auto;\n  margin: ", ";\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", "\n"])), props => " 0px 0px ".concat(get('space.16')(props), " 0px"), props => {
  const index = props.currentindex || 0;
  return props.idx === index && !props.completed && {
    'font-weight': "".concat(get('fontWeights.bold')(props)),
    color: "".concat(get('colors.functional.grey.900')(props))
  };
});
const Components = {
  StepperIndicatorWrapper,
  StepperIndicatorList,
  StepperIndicatorItem,
  StepperIndicatorItemInner,
  StepperIndicatorIconWrapper,
  StepperIndicatorItemLabel,
  StepperIndicatorItemHeader
};
export { Components };